'use strict';

/**
 *
 * @name: nnSoloPlayer
 *
 */

import DirectiveTemplate from './nn-solo-player.directive.html';

function NnSoloPlayerDirective(
  $compile,
  $rootScope,
  $location,
  localPlaylist,
  $window,
  $timeout,
  nnModalsService,
  APP_CONSTANTS) {

  'ngInject';

  return {
    replace: true,
    restrict: 'E',
    template: DirectiveTemplate,
    scope: {
      post: '&',
      list: '&',
      settings: '='
    },
    controller: soloPlayerDirectiveController,
    link: function nnSoloPlayerDirectiveLink(scope, element) {

      /*
       *
       * @CONFIG
       *
       */
      console.log(scope,12312377777777777)
      scope.newBrightcovePlayer = APP_CONSTANTS.newBrightcovePlayer;
      $rootScope.videoHeight = element.find('.additional-wrapper').height();
      var meinGott = false;
      var prev = false;
      var rootWatchers = {};

      /*
       *
       * @PUBLIC
       *
       */

      scope.goNext = function (direction) {

        switch (direction) {
          case 'next':
            // Break if current video is last on the list
            if (scope.settings.index === scope.list.length - 1) return;
            break;
          case 'prev':
            // Break if current video is first on list
            if (scope.settings.index === 0) return;
            // Break i previos video is not published
            let prevVideo = !scope.list[scope.settings.index - 1];
            if (prevVideo && prevVideo.isPublished && prevVideo.statusCn === 'published') return;
            // Set info to load previous video
            prev = true;
            break;
        }

        $rootScope.$broadcast('filmFinished');
      };

      /*
       *
       * @PRIVATE
       *
       */

      function checkIfImgLoaded() {

        var a, imgElm;
        var myInterval = setInterval(function () {

          imgElm = element.find('.post-article-type-cover img');
          a = imgElm.height();

          if (a) {

            var imgLoadedEvent;

            try {

              imgLoadedEvent = new Event('imgLoaded');
            } catch (e) {

              imgLoadedEvent = document.createEvent('Event');
              imgLoadedEvent.initEvent('imgLoaded', true, true);
            }

            document.dispatchEvent(imgLoadedEvent);
            clearInterval(myInterval);
          }
        }, 100);
      }

      /*
       *
       * @INIT
       *
       */

      scope.$on('destroyPlaya', function () {

        setTimeout(function () {

          $rootScope.$apply(function () {

            scope.$destroy();
          });
        });
      });

      rootWatchers.videoCounter = $rootScope.$watch('videoCounter', function (newVal) {

        if (newVal && newVal.length === 2 && parseInt(newVal) <= 8 && newVal !== '00') {

          element.find('.video-nav li.next > a').addClass('hoverOn');
        } else {

          element.find('.video-nav li.next > a').removeClass('hoverOn');
        }
      });

      scope.$on('$destroy', function () {

        Object.keys(rootWatchers)
          .forEach(function (killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });

        element.find('*').remove();
      });

      scope.$on('filmDun', function () {

        if (!scope.showPlaylist && !scope.showComments) {

          if (($rootScope.playlist && $rootScope.playlist.settings.active) || (scope.list && scope.list[scope.settings.index + 1])) {

            $rootScope.$broadcast('filmFinished');
          }
        }
      });

      scope.$on('nowness.openOptionPanel', function (event, option) {

        var boundingClientRect = element.find('.video-wrapper')[0].getBoundingClientRect();

        $('html, body').animate({
          scrollTop: (100 + boundingClientRect.height / 2)
        }, function () {

          scope.showComments = false;
          scope.showPlaylist = false;
          scope.showRatings = false;
          scope.toggleDd(option);
        });
      });

      scope.$on('filmFinished', function (e, data) {

        scope.toggleDd('all');

        $rootScope.noPlayer = true;
        $rootScope.ratingsJustRatedFiveStars = false;
        $rootScope.ratingsJustRatedOneStar = false;
        localPlaylist.resetCounter();

        setTimeout(function () {

          $rootScope.$apply(function () {

            $rootScope.showPersistentVideo = false;
          });
        });

        var playerContainer = element.find('.video-wrapper .video-container .video');
        var slideshowContainer = element.find('.slideshow-wrapper .slideshow-container .slideshow');

        if ((!$rootScope.playlist || !$rootScope.playlist.settings.active) && scope.list && scope.list.length > 0) {

          playerContainer.empty();
          slideshowContainer.empty();

          var listenToPost = scope.$on('postChange', function (e, post) {

            listenToPost();
            scope.wrapperHidden = true;
            scope.post = post;
            scope.runThePost();

            // NEW PLAYER
            if (APP_CONSTANTS.newBrightcovePlayer) {
              // console.log(12311)
              playerContainer.html(`
              <div class="brightcove-new" ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'brightcove\'" data-video-oster data-video-url="{{post.media[post.mainKey].metaData.playUrl}}" data-video-id="{{ post.media[post.mainKey].content }}" data-video-vtt="{{post.media[post.mainKey].metaData.subTitles}}" video-poster="{{post.imageUrl}}"></div>
              <div youtube ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'youtube\'" data-video-id="{{ post.media[post.mainKey].content }}"></div><div vimeo ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'vimeo\'" data-video-id="{{ post.media[post.mainKey].content }}"></div>
              <div data-cinematique ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'cinematique\'" data-video-id="{{ post.media[post.mainKey].content }}"></div><div black-frame ng-if="post.iframeUrl && (post.useIframeOnMobile ? true : !$root.isMobileDevice) && post.type === \'video\'" frame-src="{{ post.iframeUrl }}">
              </div>`);
            } else {
              // console.log(23456)
              playerContainer.html('<div class="brightcove"     ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'brightcove\'"  data-video-url="{{post.media[post.mainKey].metaData.playUrl}}" data-video-id="{{ post.media[post.mainKey].content }}"></div><div youtube ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'youtube\'" data-video-id="{{ post.media[post.mainKey].content }}"></div><div vimeo ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'vimeo\'" data-video-id="{{ post.media[post.mainKey].content }}"></div><div data-cinematique ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'video\' && post.source === \'cinematique\'" data-video-id="{{ post.media[post.mainKey].content }}"></div><div black-frame ng-if="post.iframeUrl && (post.useIframeOnMobile ? true : !$root.isMobileDevice) && post.type === \'video\'" frame-src="{{ post.iframeUrl }}"></div>');
            }
            // OLD PLAYER
            slideshowContainer.html('<nn-image-slider data-ng-if="(!post.iframeUrl || (post.iframeUrl && !post.useIframeOnMobile && $root.isMobileDevice)) && post.type === \'slideshow\'" images="post.slideshowImages"></div><div black-frame ng-if="post.iframeUrl && (post.useIframeOnMobile ? true : !$root.isMobileDevice) && post.type === \'slideshow\'" frame-src="{{ post.iframeUrl }}"></nn-image-slider>');
            $compile(playerContainer.contents())(scope);
            $compile(slideshowContainer.contents())(scope);
            $rootScope.$broadcast('goCompile');

            setTimeout(function () {
              $rootScope.$apply();
            });
            var tellPete;

            try {

              tellPete = new Event('playerLoad');
            } catch (e) {

              tellPete = document.createEvent('Event');
              tellPete.initEvent('playerLoad', true, true);
            }

            document.dispatchEvent(tellPete);

            if (scope.post.type === 'article') {

              checkIfImgLoaded();
            }

            $timeout(function () {

              if (post.type === 'slideshow') {

                var imageHeight = post.slideshowImages[0].metaData.height;
                element.find('.additional-wrapper').height(imageHeight);

              } else if (post.type === 'video') {

                element.find('.additional-wrapper').height(element.find('.video-wrapper').height());
                $rootScope.videoHeight = element.find('.additional-wrapper').height();
              }

              $timeout(function () {

                scope.wrapperHidden = false;
              }, 333);
            });

            prev = false;
          });

          if (!data || !data.dontGoNext) {

            if (scope.list[scope.settings.index + 1] && !prev) {

              setTimeout(function () {

                $rootScope.$apply(function () {

                  scope.settings.index++;
                });
              });
            } else if (scope.list[scope.settings.index - 1] && prev) {

              setTimeout(function () {

                $rootScope.$apply(function () {

                  scope.settings.index--;
                });
              });
            }
          }

          // below is for story player only
        } else if (meinGott === false) {

          meinGott = true;
          playerContainer.empty();
          var dir = false;

          if (prev) {
            dir = 'prev';
          }

          localPlaylist.nextStory(dir);
          prev = false;
          scope.$destroy();
        }

      });

      $timeout(function () {

        var tellPete;

        try {

          tellPete = new Event('playerLoad');
        } catch (e) {

          tellPete = document.createEvent('Event');
          tellPete.initEvent('playerLoad', true, true);
        }

        document.dispatchEvent(tellPete);

        if (scope.post.type === 'article') {

          checkIfImgLoaded();
        }
      }, 1000);

      element
        .find('.video-nav li a')
        .on('click.navArrows', function (e) {

          e.preventDefault();
        });
    }
  };
}

function soloPlayerDirectiveController(
  $scope,
  $rootScope,
  $localStorage,
  $location,
  $state,
  $element,
  $timeout,
  apiLoveService,
  localPlaylist,
  apiPostService,
  $injector,
  playersAnalytics,
  nnModalsService,
  $http,
  angularticsService) {

  'ngInject';

  var registerFb;
  if ($rootScope.lang !== 'zh-cn') {
    registerFb = $injector.get('registerFb');
  }

  /*
   *
   * @CONFIG
   *
   */

  var rootWatchers = {};

  $scope.playersAnalytics = playersAnalytics;
  $scope.post = $scope.post();
  $scope.list = $scope.list();
  $scope.displaySubtitlesReminder = angular.isDefined($localStorage.displayPlayerSubtitlesReminder) ? $localStorage.displayPlayerSubtitlesReminder : true;
  $scope.hidingSubtitlesReminder = false;

  /*
   *
   * @PUBLIC
   *
   */

  $scope.onMouseOver = function () {

    if (($rootScope.playerSubtitles || []).length) {

      $scope.hidingSubtitlesReminder = true;

      $timeout(function () {

        $localStorage.displayPlayerSubtitlesReminder = false;
        $scope.displaySubtitlesReminder = false;

        $element
          .find('.nowness-player')
          .removeClass('emulate-hover');
      }, 300);
    }
  };

  $scope.encodeURIComponent = function (text) {

    return encodeURIComponent(text);
  };

  $scope.moreShareOn = function () {

    $scope.moreShare = true;
  };

  if (registerFb) {

    $scope.facebookShare = function () {

      return registerFb.share($rootScope.appDist + $scope.post.translations[$rootScope.lang].trueSlug);
    };
  }

  $scope.runThePost = function () {

    $rootScope.post = $scope.post;

    if (!$scope.settings.aboutVideo) {

      $rootScope.seo = {
        pageTitle: $scope.post.translations[$rootScope.lang].seoTitle + ' | NOWNESS',
        metaDescription: $scope.post.translations[$rootScope.lang].seoDescription,
        image: $scope.post.socialUrl
      };
    }

    if ($rootScope.lang === 'zh-cn') {
      weChatSharing();
    }

    if ($scope.post.type === 'video') {

      $scope.post.media.some(function (item, index) {

        if (item.key === 'main') {

          $scope.post.source = item.source;
          $scope.post.mainKey = index;
          return true;
        }

        return false;
      });
    } else if ($scope.post.type === 'slideshow') {

      $scope.post.slideshowImages = [];

      if ($scope.post.media) {

        $scope.post.media.forEach(function (item) {

          if (item.key === 'main') {
            $scope.post.slideshowImages.push(item);
          }
        });

        $scope.post.slideshowImages.sort(function (a, b) {

          if (a.index > b.index) {

            return 1;
          }
          if (a.index < b.index) {

            return -1;
          }

          return 0;
        });
      }
    }

    setTimeout(function () {

      echo.init({
        offset: 300,
        throttle: 250,
        unload: false,
        // callback: function(element, op) {}
      });
    }, 888);

    if (!$scope.settings.aboutVideo) {

      apiPostService.viewPost($scope.post.id);
    }

    // The analytics call below has to be done manually, as the url doesn't reflect view change and watching the new video
    if ($state.current.name === 'main.home' || ($state.current.name === 'main.playlistSingle' && $scope.settings.index > 0)) {

      var authors = [];
      var author = [];

      if ($scope.post && $scope.post.contributors && $scope.post.contributors.length) {

        $scope.post.contributors.forEach(function (item) {

          if (item.displayName) {

            authors.push(item.displayName);
          }

          if (item.roles.indexOf('brand') !== -1) {

            author.push(item.displayName);
          }
        });
      }

      var analyticsData = {
        pageName: '/video/' + $scope.post.translations[$rootScope.lang].slug,
        pageTitle: $scope.post.translations[$rootScope.lang].title + ($state.current.name === 'main.home' ? ' | Homepage player' : ' | Playlist player'),
        pageID: 'NA',
        primaryCategory: 'article',
        subCategory1: ($state.current.name === 'main.home' ? 'homepage' : 'playlist'),
        subCategory2: 'article',
        pageType: 'article',
        attributes: {
          videoID: $scope.post.id,
          videoName: $scope.post.translations[$rootScope.lang].title,
        },
        pageAttributes: {
          articleName: $scope.post.translations[$rootScope.lang].title,
          articlePublisher: author.join(', '),
          articleAuthor: authors.join(', ')
        }
      };

      if ($state.current.name === 'main.home') {

        analyticsData.pageAttributes.articleName = 'not applicable';
      }

      angularticsService.pageTrack(analyticsData);
    }
  };

  $scope.checkIfToggleDdRatings = function () {

    if ($rootScope.profile) {

      // user clicked outside the rating control
      var action = $scope.showRatings ? 'Ratings_close_dropdown' : 'Ratings_open_dropdown';
      playersAnalytics.videoAction(action);
      $scope.toggleDd('ratings');
    } else if (!$rootScope.profile) {

      rootWatchers.profileB = $rootScope.$watch('profile', function (newVal) {

        if (newVal) {

          rootWatchers.profileB();
          $rootScope.loadItInBackground();
        }
      });
      $rootScope.postToLove = $scope.post;
      $rootScope.toBeLoved = true;

      nnModalsService.showModal('login')

      setTimeout(function () {

        $scope.$apply();
      });
    }
  };

  $rootScope.loadItInBackground = function () {

    apiPostService
      .getPostById($scope.post.id)
      .then(function (res) {

        if (res.data) {

          $scope.post.isLoved = res.data.isLoved;
          $scope.post.userRating = res.data.userRating;
          $rootScope.$broadcast('reloadRates');
        }
      });
  };

  $scope.toggleDd = function (option) {

    if (option === 'comments') {

      $scope.showComments = !$scope.showComments;
      $scope.showPlaylist = false;
      $scope.showCredits = false;
      $scope.showRatings = false;
    }
    if (option === 'playlist') {

      $scope.showComments = false;
      $scope.showPlaylist = !$scope.showPlaylist;
      $scope.showCredits = false;
      $scope.showRatings = false;
    }
    if (option === 'credits') {

      $scope.showComments = false;
      $scope.showPlaylist = false;
      $scope.showCredits = !$scope.showCredits;
      $scope.showRatings = false;
    }
    if (option === 'ratings') {

      $scope.showComments = false;
      $scope.showPlaylist = false;
      $scope.showCredits = false;
      $scope.showRatings = !$scope.showRatings;
    }
    if (option === 'all') {

      $scope.showComments = false;
      $scope.showPlaylist = false;
      $scope.showCredits = false;
      $scope.showRatings = false;
    }
  };

  $scope.love = function () {

    if ($scope.post.isLoved === false && $rootScope.profile) {

      apiLoveService
        .lovePost($scope.post.id)
        .then(function () {

          $scope.post.isLoved = true;
        });
    } else if ($scope.post.isLoved === true && $rootScope.profile) {

      apiLoveService
        .unlove($scope.post.id)
        .then(function () {

          $scope.post.isLoved = false;
        });
    } else if (!$rootScope.profile) {

      $rootScope.postToLove = $scope.post;
      $rootScope.toBeLoved = true;

      rootWatchers.profileA = $rootScope.$watch('profile', function (newVal) {

        if (newVal) {

          apiLoveService
            .lovePost($scope.post.id)
            .then(function () {

              $scope.post.isLoved = true;
            }, function () {

              $scope.post.isLoved = true;
            });

          rootWatchers.profileA();
        }
      });

      nnModalsService.showModal('login')
    }
  };

  $scope.bookmark = function () {

    if ($rootScope.playlist.idList[$scope.post.id] === undefined) {

      localPlaylist
        .addBookmark($scope.post)
        .then(function () {

          $scope.post.isBookmarked = true;
        });
    } else if ($rootScope.playlist.idList[$scope.post.id] >= 0) {

      localPlaylist
        .removeBookmark($scope.post)
        .then(function () {

          $scope.post.isBookmarked = false;
        });
    }
  };

  /*
   *
   * @PRIVATE
   *
   */

  function weChatSharing() {

    var getTicket = 'https://nowness.yund.co/GetSignPackage.php';

    var params = {
      title: $rootScope.seo.pageTitle,
      desc: $rootScope.seo.metaDescription,
      link: $location.$$absUrl,
      imgUrl: $rootScope.seo.image
    };

    $http
      .get(getTicket, {
        data: { url: $location.$$absUrl.split('#')[0] }
      })
      .success(function (data) {

        wx.config({
          debug: false,
          appId: data.appId,
          nonceStr: data.nonceStr,
          timestamp: data.timestamp,
          signature: data.signature,
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
        });

        wx.ready(function () {
          wx.onMenuShareAppMessage(params);
          wx.onMenuShareTimeline(params);
          wx.onMenuShareQQ(params);
          wx.onMenuShareWeibo(params);
          wx.onMenuShareQZone(params);
        });
      });
  }

  /*
   *
   * @INIT
   *
   */

  $scope.$on('activateList', function (e, list) {

    $scope.list = list;
  });

  $scope.$on('deactivateList', function () {

    $scope.list = [];
  });

  $scope.$on('$destroy', function () {

    Object.keys(rootWatchers)
      .forEach(function (killWatcherKey) {

        rootWatchers[killWatcherKey]();
      });
  });


  $scope.runThePost();
}

export default NnSoloPlayerDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-solo-player/nn-solo-player.directive.js